import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ActiveLoaderRecord } from '../../models/loading.models';
import { LoaderRegistryService } from '../../services/loader-registry.service';

@Component({
  selector: 'myt-app-fullscreen-loader-overlay',
  templateUrl: './app-fullscreen-loader-overlay.component.html',
  styleUrls: ['./app-fullscreen-loader-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppFullscreenLoaderOverlayComponent {
  readonly activeFullscreenLoader$: Observable<ActiveLoaderRecord | null> =
    this.loaderRegistryService.selectActiveFullscreenLoader();

  constructor(private readonly loaderRegistryService: LoaderRegistryService) {}
}
